<template>
  <div class="container">
    <el-container>
      <el-header><Header></Header></el-header>
      <el-container>
        <!-- 只在非登录页显示侧边栏，并动态设置宽度 -->
        <el-aside v-if="defaultActive !== '/login'" :width="asideWidth">
          <Menu @update:collapsed="handleCollapsedChange" />
        </el-aside>
        <el-main :class="{'router-main': defaultActive !== '/login', 'main-collapsed': isMenuCollapsed}">
          <router-view class="main-router-view" :class="{'router-main-class': defaultActive == '/login'}" />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import Menu from "./Menu";
import Header from "./Header";

export default {
  components: { Menu, Header },
  data() {
    return {
      isMenuCollapsed: false, // 控制菜单收放状态
    };
  },
  computed: {
    defaultActive() {
      const path = this.$route.path;
      const re = /^(\/[^/]*)/g;
      return re.exec(path)[1];
    },
    asideWidth() {
      return this.isMenuCollapsed ? '68px !important' : '180px !important';
    }
  },
  methods: {
    handleCollapsedChange(collapsed) {
      this.isMenuCollapsed = collapsed;
    }
  }
};
</script>

<style scoped>
.container {
  min-height: 100%;
  background-color: #F3F3F3;
}
.container,
.is-vertical {
  padding: 0;
  margin: 0;
  min-height: 100vh;
}
.el-header {
  height: auto !important;
  padding: 0;
}

/* 侧边栏过渡效果 */
.el-aside {
  transition: width 0.3s ease;
  background-color: #fff;
  overflow-y: auto;
  overflow-x: hidden;
}

/* 主内容区域样式 */
.router-main {
  padding: 0 20px;
  padding-top: 30px;
  padding-bottom: 50px;
  transition: padding-left 0.3s ease;
}

/* 菜单收起时主内容区域可以微调 */
.router-main.main-collapsed {
  /* 如果需要，可以在这里添加收起时的特殊样式 */
}

.main-router-view {
  flex-grow: 1;
  overflow: hidden;
  height: 100%;
  padding: 5px 5px;
  background-color: #fff;
  border-radius: 8px;
  min-height: calc(100vh - 140px); /* 根据布局调整 */
}

.el-main {
  padding: 5px;
  background-color: #e4e7ed;
}

.router-main-class {
  display: flex;
  justify-content: center;
  height: auto;
  align-items: center;
}

/* 自定义滚动条样式 */
.el-aside::-webkit-scrollbar {
  width: 4px;
}

.el-aside::-webkit-scrollbar-thumb {
  background-color: #ddd;
  border-radius: 2px;
}

.el-aside::-webkit-scrollbar-track {
  background-color: #f5f5f5;
}
</style>